
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1031"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1031",
    "ar-eg": "static-7.1031",
    "bg": "static-7.1031",
    "bn": "static-7.1031",
    "ca-es": "static-7.1031",
    "cs": "static-7.1031",
    "da": "static-7.1031",
    "de": "static-7.1031",
    "el": "static-7.1031",
    "en-gb": "static-7.1031",
    "en": "static-7.1031",
    "es-mx": "static-7.1031",
    "es": "static-7.1031",
    "et": "static-7.1031",
    "fi": "static-7.1031",
    "fr-ca": "static-7.1031",
    "fr": "static-7.1031",
    "he-il": "static-7.1031",
    "hi": "static-7.1031",
    "hr": "static-7.1031",
    "hu": "static-7.1031",
    "id": "static-7.1031",
    "it": "static-7.1031",
    "ja": "static-7.1031",
    "ko": "static-7.1031",
    "lt": "static-7.1031",
    "ms": "static-7.1031",
    "nl": "static-7.1031",
    "no": "static-7.1031",
    "pl": "static-7.1031",
    "pt-br": "static-7.1031",
    "pt-pt": "static-7.1031",
    "ro": "static-7.1031",
    "ru": "static-7.1031",
    "sk": "static-7.1031",
    "sl": "static-7.1031",
    "sv": "static-7.1031",
    "th": "static-7.1031",
    "tl": "static-7.1031",
    "tr": "static-7.1031",
    "uk": "static-7.1031",
    "vi": "static-7.1031",
    "x-pseudo": "static-7.1031",
    "zh-cn": "static-7.1031",
    "zh-hk": "static-7.1031",
    "zh-tw": "static-7.1031"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1031'}); }
})();


